// extracted by mini-css-extract-plugin
module.exports = {"scannerCards":"receipt-document-scanners_scannerCards__GY13d","scannerCard":"receipt-document-scanners_scannerCard__sLrGf"};